import ListModule from "../../../../layout/components/CRUD/List/List";

function List() {
  return (
    <ListModule module="enquiries" modulePath="/enquiries" primary_id="enquiry_id" />
  );
}

export default List;
